/// <reference path="../registerSectionBase.ts" />

module Meevo.Plugins.Register {
    "use strict";

    export class LotSelectionSection extends Meevo.Plugins.Register.RegisterSectionBase {

        get $scope() { return this.registerContext.$scope; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.LotSelection, registerContext, "productLot", Register.RegisterSectionCatTypeEnum.Sale);
        }

        // The lot screen operates on the in-progress (temp) sale line set by the products section.
        get saleLine(): Model.SaleLine {
            return this.registerContext.tempSaleLines && this.registerContext.tempSaleLines.length
                ? this.registerContext.tempSaleLines[0]
                : null;
        }

        hasSelectedLot(): boolean {
            return this.getSelectedLotAllocations().length > 0;
        }

        // Next: with a lot entered, run the lot-keyed historical match check. On a confirmed match
        // addRefundSaleLine adds the line from history and invokes this reset (return to product
        // selection); on "No" or no match it routes to employee selection, carrying the lots entered
        // here on the temp line. With no lot entered, skip the check and go straight to employee.
        next() {
            const saleLine = this.saleLine;
            if (!saleLine) {
                return;
            }

            if (!this.hasSelectedLot()) {
                this.registerContext.selectSection(RegisterSectionTypeEnum.Employee);
                return;
            }

            this.addRefundSaleLine(saleLine.item.id, Model.SalesTypeEnum.Product, () => {
                this.registerContext.selectSection(RegisterSectionTypeEnum.Products);
            });
        }

        reset() {
        }
    }
}
